// Application configuration
const rawUrl = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '';

// Normalize: ensure trailing slash so axios resolves relative paths correctly.
// If no env var is set, fall back to same-origin (works when frontend & backend share a domain).
const apiUrl = rawUrl
  ? rawUrl.replace(/\/+$/, '') + '/'
  : window.location.origin + '/';

// Base URL of the Odoo tenant for "View in Odoo" deep links.
// Set via VITE_ODOO_BASE_URL in Coolify env vars.
const odooBaseUrl = (import.meta.env.VITE_ODOO_BASE_URL || '').replace(/\/+$/, '');

const config = { apiUrl, odooBaseUrl };

export default config;
